import TheaterButton from './TheaterButton';
import TheaterButtonContainer from './TheaterButton.container';
export default TheaterButtonContainer(TheaterButton);
//# sourceMappingURL=index.js.map